import AsyncStorage from "@react-native-async-storage/async-storage";
import axios, { AxiosError } from "axios";
import jwt_decode from "jwt-decode";
import { showMessage } from "react-native-flash-message";
import { USE_MOCK_API, mockAdapter } from "../mocks";

export const API_URI = "https://api-staging.4schools.io";
export const isic_get_card_microservice = "https://api-staging.4schools.io";
// export const API_URI = "http://localhost:8001";
// export const isic_get_card_microservice = "http://localhost:8001";
// export const API_URI = "https://api.4schools.io";
// export const isic_get_card_microservice = "https://api.4schools.io";
export const discounts_4schools_image_path =
	"https://api-staging.4schools.io/users/discounts/documents/images/";
export const TOKEN_STORAGE_KEY = "@userToken";
export const REFRESH_TOKEN_STORAGE_KEY = "@refreshUserToken";

interface ExpectedToken {
	iat: number;
	exp: number;
	user_id: string;
}

const apiCall = axios.create({
	baseURL: API_URI,
});

// In mock mode every request is answered from src/mocks/fixtures.ts instead of
// reaching the network. Installing it as the adapter keeps the interceptors
// below — and every call site in store/services — untouched.
if (USE_MOCK_API) {
	apiCall.defaults.adapter = mockAdapter;
}

let preventMultiplesRequests = false;

apiCall.interceptors.request.use(async config => {
	const token = await AsyncStorage.getItem(TOKEN_STORAGE_KEY);
	const refreshToken = await AsyncStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);

	if (token === null) return config;

	config.headers = {
		Authorization: "Bearer " + (token ?? null),
	};

	if (config.url === "/users/login/signin") return config;

	const decodedJwt = token && jwt_decode<ExpectedToken>(token);
	const jwtExpTime = decodedJwt && decodedJwt.exp;
	const now = Math.floor(Date.now() / 1000);
	const validToken = jwtExpTime && jwtExpTime - now > 2;

	if (validToken) return config;

	const instance = axios.create({
		// eslint-disable-next-line no-undef
		baseURL: API_URI,
	});

	if (!preventMultiplesRequests) {
		preventMultiplesRequests = true;
		return new Promise((resolve, reject) => {
			instance
				.post("/users/login/refresh", {
					token: token,
					refresh_token: refreshToken,
				})
				.then(async response => {
					const newToken = response.data.token;
					const newRefreshToken = response.data.refresh_token;

					await AsyncStorage.setItem(TOKEN_STORAGE_KEY, newToken);
					await AsyncStorage.setItem(
						REFRESH_TOKEN_STORAGE_KEY,
						newRefreshToken
					);

					config.headers = {
						Authorization: "Bearer " + (newToken ?? null),
					};

					resolve(config);

					setTimeout(() => {
						preventMultiplesRequests = false;
					}, 2000);
				})
				.catch(e => {
					console.log({
						error: e.response?.data,
						status: e.response?.status,
					});
					if (e.response.status === 404) {
						showMessage({
							type: "danger",
							message: "Unexpected behavior, please log out and try again!",
						});
					}

					reject(config);
				});
		});
	}

	return config;
});
apiCall.interceptors.response.use(
	res => {
		return res;
	},
	(error: AxiosError) => {
		console.log("Err", error?.response);

		return Promise.reject(error);
	}
);

export default apiCall;
